import { Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekSkeleton = styled(Skeleton)(({ theme }) => ({}));

export { PeekSkeleton, PeekSkeleton as default };
